module.exports = __webpack_public_path__ + "static/media/logout.960f8445.svg";